import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import Breadcrumb from '../components/Breadcrumb'
import LoanDetails from '../components/child/LoanDetails'
import LoanMappings from '../components/child/LoanMappings'

const LoanMapping = () => {
  return (
    <MasterLayout>

    {/* Breadcrumb */}
    <Breadcrumb title="Loan Mapping" />

    {/* TableDataLayer */}
    <LoanMappings/>

  </MasterLayout>  )
}

export default LoanMapping